
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  props: {
    type: {
      type: String,
      default: 'default',
      validator: (value: string) => ['default', 'table', 'card', 'map', 'jobitem', 'header'].includes(value)
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '200px'
    },
    columns: {
      type: Number,
      default: 4
    },
    rows: {
      type: Number,
      default: 5
    }
  }
})
export default class LoadingSkeleton extends Vue {}
